exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rx-switch{position:relative;width:26px;height:14px;background:#424242;margin-top:4px;border-radius:6px;cursor:pointer}.rx-switch:after{content:\"\";position:absolute;top:-1px;left:-1px;height:16px;width:16px;background:#e0e0e0;border-radius:50%;box-shadow:2px 2px 5px 0 rgba(0,0,0,.4)}.rx-switch.on{background:#75b325}.rx-switch.on:after{content:\"\";position:absolute;top:-1px;left:auto;right:-1px;height:16px;width:16px;background:#e0e0e0;border-radius:50%;box-shadow:2px 2px 5px 0 rgba(0,0,0,.4)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b107e8f8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/inputs/RxSwitch.vue
// module id = 79
// module chunks = 0 1